import {ContentTypes, getApi} from "../../common/actions/net.js";
import {messageType, pushSystemMessage} from "../../common/actions/systemMessage.js";

import Logger from "../../common/util/Logger.js";
import { makeApiUrl } from "../../common/util/config.jsx";

export const CHANGE_SUPPORT_MESSAGE = "CHANGE_SUPPORT_MESSAGE";
export const CLEAR_SUPPORT_MESSAGE = "CLEAR_SUPPORT_MESSAGE";
export const FAQ_IS_LOADING = "FAQ_IS_LOADING";
export const FAQ_DONE_LOADING = "FAQ_DONE_LOADING";
export const FAQ_FAILED_LOADING = "FAQ_DONE_LOADING";
export const SET_FAQ_RESULTS = "SET_FAQ_RESULTS";

const setFaqIsLoading = () => ({
    type: FAQ_IS_LOADING,
});

const setFaqDoneLoading = () => ({
    type: FAQ_DONE_LOADING,
});

const setFaqFailedLoading = () => ({
    type: FAQ_FAILED_LOADING,
});

const addFaqResults = (faqArray) => ({
    type: SET_FAQ_RESULTS,
    results: faqArray,
});

/**
 * Get FAQ
 * @returns {func}
 */
export function getFaq(){
    return async (dispatch) => {
        try {
            // Start loading
            dispatch( setFaqIsLoading() );

            const {payload} = await dispatch(getApi("Help/FaqQuery"));

            // Store query results
            await dispatch(addFaqResults(payload));

            dispatch(setFaqDoneLoading());
        } catch (error) {
            dispatch( setFaqFailedLoading());
            dispatch(pushSystemMessage(error && error.message || "Innlasting av faq mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 *Edit support message
 * @param {object} change 
 * @returns {func}
 */
export function editMessage(change){
    return async (dispatch) => {
        dispatch({
            type: CHANGE_SUPPORT_MESSAGE,
            change,
        });
    };
}

/**
 *Clears all data regarding the support message
 * @returns {func}
 */
export function clearMessage(){
    return async (dispatch) => {
        dispatch({
            type: CLEAR_SUPPORT_MESSAGE
        });
    };
}

/**
 * Submit help message
 * @returns {func}
 */
export function submitSupportMessage(){
    return async (dispatch, getState) => {
        try {
            const state = getState();
            // Start loading
            dispatch( setFaqIsLoading() );

            const formData = new FormData();

            formData.append("Subject", state.support.message.subject);
            formData.append("Message", state.support.message.messageInput);
            
            if(state.support.message.files && state.support.message.files.length>0){
                for(let i=0; i<state.support.message.files.length; i++){
                    formData.append("Attachments", state.support.message.files[i]);
                }
            }

            const headers = new Headers();
            headers.append("Accept", ContentTypes.JSON);
            headers.append("Authorization", `Bearer ${state.authentication.token}`);

            //const payload = await dispatch(postApi("Help/WebMessageUploadCommand",formData,ContentTypes.FORM));
            const response = await fetch(makeApiUrl("Help/WebMessageUploadCommand"), {
                method: "POST",
                headers,
                body: formData
            });

            if( response.ok===true ){
                dispatch( clearMessage() );
                dispatch( pushSystemMessage("Melding sendt", messageType.message) );
            } else {
                dispatch( pushSystemMessage("Meldingen kunne ikke sendes", messageType.error) );
            }

            dispatch(setFaqDoneLoading());
        } catch (error) {
            dispatch( setFaqFailedLoading());
            dispatch(pushSystemMessage(error && error.message || "Feil: Meldingen kunne ikke sendes", messageType.error));
            Logger.error(error);
        }
    };
}
